import React from 'react';
import styles from './SearchInput.module.scss';
import { Icon, Input } from 'antd';
import cn from 'classnames';

const SearchInput = ({ className, ...props }) => {
  return (
    <Input
      {...props}
      type="text"
      className={cn(styles.input, className)}
      suffix={<Icon type="search" />}
    />
  );
};

export default SearchInput;
